export default {
  "pl": {
    "partner": {
      "actions": {
        "add": "Dodaj",
        "changeProfilePicture": "Zmień zdjęcie profilowe",
        "new": "Nowy partner",
        "profilePictureFormat": "Minimalne wymiary to: 300 ⨯ 300 px",
        "save": "Zapisz",
        "sendinvitation": "Wyślij zaproszenie",
        "submit": "Zapisz",
        "undoChanges": "Cofnij"
      },
      "attributes": {
        "email_address": "E-mail",
        "email_notifications_interval": {
          "daily": "Raz dziennie (ok. południa)",
          "hourly": "Co godzinę",
          "twice_daily": "Dwa razy dziennie (rano i w południe)",
          "weekly": "Raz w tygodniu (w poniedziałek w południe)"
        },
        "first_name": "Imię",
        "internal_note": "Notatka do użytku wewnętrznego",
        "language": "Język",
        "last_name": "Nazwisko",
        "phone_landline": "Numer stacjonarny",
        "phone_mobile": "Numer telefonu komórkowego",
        "profession": "Stanowisko",
        "session_ended_at": "Ostatnia aktywność",
        "status": "Status",
        "title": "Tytuł"
      },
      "labels": {
        "addExistingCompany": "Dodaj do istniejącej firmy",
        "contactDetails": "Dane kontaktowe",
        "createNewCompany": "Utwórz nową firmę",
        "information": "Informacje profilowe",
        "newTeamMember": "Nowy partner",
        "notEditable": "Edycja jest możliwa tylko w przypadku nieaktywnych partnerów",
        "partnerAddedState": "<b>Jeszcze nie zaproszono</b>. Zaproszenie zostanie wysłane, kiedy partner {partner_name} uzyska dostęp do opublikowanej decyzji lub dokumentu.",
        "selectedCompany": "Wybrana firma"
      },
      "toasts": {
        "create": "Utworzono konto partnera",
        "update": "Zaktualizowano dane partnera"
      },
      "validation": {
        "mustBeEmailAddress": "Należy podać poprawny adres e-mail",
        "needFirstName": "Należy podać imię",
        "needLastName": "Należy podać nazwisko",
        "requireEmailAddress": "Należy podać adres e-mail"
      }
    }
  }
}
